import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { TagCountTag, TagPicker } from '../tags';
import { useAmplitude, useCurrentUser, useLinkTag, useSonarObjectReference, useUnlinkTag } from '@hooks';
export const SonarTagManager = ({ sonarObjectId }) => {
    var _a, _b;
    const logEvent = useAmplitude();
    const { isReadOnly } = useCurrentUser();
    const { request: requestLink } = useLinkTag();
    const { request: requestUnlink } = useUnlinkTag();
    const selectedTagIds = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.tagIds) !== null && _b !== void 0 ? _b : [];
    const linkTag = useCallback((tagId) => {
        requestLink({
            sonarObjectIds: [sonarObjectId],
            sonarObjectTagId: tagId
        });
        logEvent(AMPLITUDE_EVENT.TAG_LINKED, {
            objectType: SonarObjectType.SalesforceField
        });
    }, [logEvent, requestLink, sonarObjectId]);
    const unlinkTag = useCallback((tagId) => {
        requestUnlink({
            sonarObjectId,
            sonarObjectTagId: tagId
        });
        logEvent(AMPLITUDE_EVENT.TAG_UNLINKED, {
            objectType: SonarObjectType.SalesforceField
        });
    }, [logEvent, requestUnlink, sonarObjectId]);
    if (isReadOnly) {
        return React.createElement(TagCountTag, { count: selectedTagIds.length });
    }
    return (React.createElement(TagPicker, { onDeselect: unlinkTag, onSelect: linkTag, selectedTagIds: selectedTagIds },
        React.createElement(TagCountTag, { count: selectedTagIds.length })));
};
